import { Icon } from "@circle-react-shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface DefaultLoaderProps {
  center?: boolean;
  className?: string;
}

export const DefaultLoader = ({
  className = "",
  center = false,
}: DefaultLoaderProps) => (
  <div
    data-testid="default-loader"
    className={classNames(
      legacyClassNames("react-loader default-loader"),
      "mx-auto p-4 text-center",
      {
        "m-auto": center,
      },
      className,
    )}
  >
    <Icon type="loader" />
  </div>
);
